import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import GeneralStats from './GeneralStats';
import UsageAnalytics from './UsageAnalytics';
import './SystemAnalytics.scss';

const SystemAnalytics = () => {
    const [activeTab, setActiveTab] = useState('general');
    const { t } = useLanguage();

    return (
        <div className="system-analytics">
            <div className="analytics-header">
                <h1>{t('systemAnalytics')}</h1>
                <p>{t('systemAnalyticsDescription')}</p>
            </div>

            <div className="analytics-tabs">
                <button
                    className={`tab-button ${activeTab === 'general' ? 'active' : ''}`}
                    onClick={() => setActiveTab('general')}
                >
                    {t('generalStats')}
                </button>
                <button
                    className={`tab-button ${activeTab === 'usage' ? 'active' : ''}`}
                    onClick={() => setActiveTab('usage')}
                >
                    {t('usageAnalytics')}
                </button>
            </div>

            <div className="analytics-content">
                {activeTab === 'general' && <GeneralStats />}
                {activeTab === 'usage' && <UsageAnalytics />}
            </div>
        </div>
    );
};

export default SystemAnalytics;